// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// © Copyright Utrecht University (Department of Information and Computing Sciences)

import React from 'react'
import './StatusIndicator.css'

// Function based component that renders a status indicator with color based on status
function StatusIndicator({ status }) {
  if (!status) {
    return null
  }

  // Get the first letter of the status
  const statusLetter = status.charAt(0).toUpperCase()

  // Determine the color class based on status
  let colorClass = 'status-other' // default
  if (status === 'ACTIVE') {
    colorClass = 'status-active'
  } else if (status === 'WITHDRAWN' || status === 'SUSPENDED') {
    colorClass = 'status-warning'
  } else {
    colorClass = 'status-other'
  }

  return (
    <div
      className={`status-indicator ${colorClass}`}
      title={status}
      aria-label={`Status: ${status}`}
    >
      {statusLetter}
    </div>
  )
}

export default StatusIndicator
